import {downLoadSuccess} from "./download";

export async function getCaptcha() {
    downLoadSuccess.set(true)
    const response = await fetch('/api/ehrequests/captcha', {
        method: 'GET',
        referrer: ''
    })
    return await response.json()
}